import React from "react";

import {
  Button,
  FormError,
  FormInput,
  FormLabel,
} from "../../../Components/Basic";
import { customClasses } from "../../../Styles/customClasses";
//form
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Loader } from "../../../Components/Basic/Loader";

import enterEmailPic from "../../../Assets/enterEmail.png";
// schema
const userContactSchema = yup.object().shape({
  user_email: yup
    .string()
    .email("Check your email")
    .required("This is required")
    .nullable(),
});

function UserContactGate({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(userContactSchema),
  });
  return (
    <form id="divorce-form" onSubmit={handleSubmit(onSubmit)}>
      <section className=" mx-auto  w-5/6 md:w-2/3 lg:w-4/5 xl:w-4/6 flex ">
        <div className="flex-1 invisible md:visible">
          <img
            className="h-5/6 w-auto object-contain"
            src={enterEmailPic}
            alt="find out if you can get divorced"
          />
        </div>
        <div className="sm:flex-10 md:flex-1 h-screen flex flex-col justify-center">
          <div className=" flex flex-col justify-center bg-gray-50 h-5/6 md:h-5/6 rounded shadow-lg px-10 pt-10 ">
            <p className="text-3xl font-bold text-nativeBlue-200">
              Your results are coming right up....
            </p>
            <p className={customClasses.questionText}>
              What’s your email address? *
            </p>
            <FormInput
              placeholder="example@gmail.com"
              id="user_email"
              type="email"
              name="user_email"
              error={errors?.user_email?.message}
              register={register}
              className="mt-4"
            />
            <FormError error={errors.user_email?.message} />
            <p className="my-5">We’ll check if you’re able to get divorced.</p>
            <p>If you can, we’ll let you know the costs involved.</p>
            <Button
              type="submit"
              fontSize="lg"
              form="divorce-form"
              className="mt-10 w-full md:max-w-xs mx-3 md:mx-0 focus:outline-none p-4 bg-nativeOrange-200 hover:bg-yellow-500  hover:border-yellow-500"
            >
              Find Out
            </Button>
          </div>
        </div>
      </section>
    </form>
  );
}

export default UserContactGate;
